// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__37TOT","big":"index_big__3NXmg","brumer":"index_brumer__RkkZD","small":"index_small__oP9jP"};